module.exports = __webpack_public_path__ + "img/icon_hospital_white.c1124e44.svg";